window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      let debouncedListOrGridToggle;

      const listOrGridToggle = () => {
        if (window.innerWidth > window.appConfig.MOBILE_WIDTH_THRESHOLD_2) {
          if (debouncedListOrGridToggle) {
            window.removeEventListener('resize', debouncedListOrGridToggle);
          }

          function toggleViewMode(viewType) {
            const isGrid = viewType === 'grid';

            const clickedElement = document.querySelector(`.list-or-grid .${viewType}`);
            clickedElement.classList.add('active');
            clickedElement.parentElement
              .querySelectorAll('.list-or-grid .list, .list-or-grid .grid')
              .forEach((sibling) => {
                if (sibling !== clickedElement) sibling.classList.remove('active');
              });

            const productGrid = document.querySelector('.product-grid');
            productGrid.classList.add('is-active');
            setTimeout(() => {
              if (isGrid) {
                productGrid.classList.add('style-is-grid');
              } else {
                productGrid.classList.remove('style-is-grid');
              }
            }, 400);

            setTimeout(() => {
              productGrid.classList.remove('is-active');
            }, 600);

            document.querySelectorAll('.cpap__pagination a').forEach((anchor) => {
              let href = anchor.getAttribute('href');
              if (isGrid) {
                href = `${href}#grid`;
              } else {
                href = href.replace('#grid', '');
              }
              anchor.setAttribute('href', href);
            });
          }
          ['list', 'grid'].forEach((viewType) => {
            document
              .querySelector(`.grid-heading .list-and-sort .list-or-grid .${viewType}`)
              .addEventListener('click', function () {
                toggleViewMode(viewType);
              });
          });
        }
      };

      if (window.innerWidth > window.appConfig.MOBILE_WIDTH_THRESHOLD_2) {
        listOrGridToggle();
      } else {
        // Use post task to yield to the main thread and process in the background during idle
        window.scheduler.postTask(
          () => {
            // Don't add the resize listener for actual mobile devices to save resources
            if (!window.cpap.isMobileDevice()) {
              debouncedListOrGridToggle = window.cpap.debounce(listOrGridToggle, 1000);

              // Update calculations on resize without re-attaching scroll event
              window.addEventListener('resize', debouncedListOrGridToggle, {
                passive: true,
              });
            }
          },
          { priority: 'background' }
        );
      }
    },
    { priority: 'user-blocking' }
  );
});
